export default [
  {
    path: 'GoldManagement',
    name: 'GoldManagement',
    meta: {
      title: "goldAccountManagement",
    },
    component: () => import('@/views/Home/AgentProvider/GoldManagement/GoldManagement'),
  },
  {
    path: 'Application',
    name: 'Application',
    meta: {
      title: '代理商服务商申请',
    },
    component: () => import('@/views/Home/AgentProvider/Application/index.vue'),
  },
]
